import { SET_CLIENT_PRESSRELEASE } from "../actions/action-types.js";

export default function clientPressRelease(state = {}, {type, payload}) {
    switch (type) {
        case SET_CLIENT_PRESSRELEASE:
            return (state = payload)
        default:
            return state
    }
}